var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagTun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2242 3341)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_528",
    "data-name": "Ret\\xE2ngulo 528",
    width: 102.825,
    height: 59.988,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_TUN",
    transform: "translate(-2242 -3341)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_tunisia",
    transform: "translate(2220.369 3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_527",
    "data-name": "Ret\\xE2ngulo 527",
    width: 102.825,
    height: 59.988,
    transform: "translate(0 0)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_842",
    "data-name": "Grupo 842",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_841",
    "data-name": "Grupo 841",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8198",
    "data-name": "Caminho 8198",
    d: "M377.06,8.741a15,15,0,1,1-15.009,15,15,15,0,0,1,15.009-15",
    transform: "translate(-325.641 6.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8199",
    "data-name": "Caminho 8199",
    d: "M375.5,10.934a11.245,11.245,0,1,1-11.263,11.239A11.247,11.247,0,0,1,375.5,10.934",
    transform: "translate(-324.081 7.81)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8200",
    "data-name": "Caminho 8200",
    d: "M376.308,12.246a8.995,8.995,0,1,1-9.007,8.988,9,9,0,0,1,9.007-8.988",
    transform: "translate(-321.891 8.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8201",
    "data-name": "Caminho 8201",
    d: "M368.617,17.953l6.421,2.095,1.041-3.207",
    transform: "translate(-320.951 12.029)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8202",
    "data-name": "Caminho 8202",
    d: "M368.617,18.352l6.421-2.071,1.041,3.207",
    transform: "translate(-320.951 11.63)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8203",
    "data-name": "Caminho 8203",
    d: "M371.337,13.747V20.5h3.368",
    transform: "translate(-319.009 9.82)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8204",
    "data-name": "Caminho 8204",
    d: "M371.337,13.747l3.967,5.47L372.569,21.2",
    transform: "translate(-319.009 9.82)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8205",
    "data-name": "Caminho 8205",
    d: "M371.337,24.341l3.967-5.47L372.569,16.9",
    transform: "translate(-319.009 12.069)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8206",
    "data-name": "Caminho 8206",
    d: "M371.337,24.052V17.3h3.368",
    transform: "translate(-319.009 12.358)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8207",
    "data-name": "Caminho 8207",
    d: "M378.408,15.178l-6.415,2.095,1.041,3.219",
    transform: "translate(-318.54 10.842)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8208",
    "data-name": "Caminho 8208",
    d: "M378.525,15.178l-3.962,5.458-2.734-1.975",
    transform: "translate(-318.657 10.842)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8209",
    "data-name": "Caminho 8209",
    d: "M378.525,22.094l-3.962-5.47-2.734,1.987",
    transform: "translate(-318.657 11.874)",
    fill: "#d30025"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8210",
    "data-name": "Caminho 8210",
    d: "M378.408,22.029l-6.415-2.095,1.041-3.219",
    transform: "translate(-318.54 11.939)",
    fill: "#d30025"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTun);
export default __webpack_public_path__ + "static/media/flag_TUN.9e1c721b8fb4ad6666a636a7f595653a.svg";
export { ForwardRef as ReactComponent };